import React from 'react'

function SpecialLunchOffer() {
  return (
    <section className="special-launch-offer" id="special-launch-offer">
        <div className="row ">
            <div className="container">
                <div className="special-launch ">
                    <div className="top-content">
                        <div className="title wow zoomIn">
                            <h2>Special Launch Offer – <span className="red">Save 25% Your First Year</span></h2>
                        </div>
                        <ul className="special-launch-box">
                            <li className="wow fadeInLeft">
                                <div className="popup-image">
                                    <b>25%</b><span>OFF</span></div>
                                    <p>You Save <b>$250/Month</b></p>
                                <p style={{paddingTop: '0px'}}>First 50 subscribers get 25% off — just $750/month (regularly $1,000).</p>
                                {/* <p>As a <b>First 50</b> subscriber, you’ll lock in 25% off your first year of
                                    Snapshot Videos.</p> */}
                                
                            </li>
                            <li className="wow zoomIn">
                                <div className="popup-image"><img src="/images/firstFifty-images/cancel-icon.png"
                                        alt="Cancel anytime" /></div>
                                {/* <p>No long-term contract. <b>Cancel anytime.</b></p> */}
                                <p><b>No long-term contract.</b></p>
                                <p style={{paddingTop: '0px'}}> Enjoy flexibility and peace of mind. Cancel anytime — no strings attached.</p>
                            </li>
                            <li className="wow fadeInRight">
                                <div className="popup-image"><img src="/images/firstFifty-images/communication-icon.png"
                                        alt="Communication" /></div>
                                <p><b>Simple, Affordable, High-Impact</b></p>
                                <p style={{paddingTop: '0px'}}>Professional videos delivered every month to keep your audience engaged without breaking the budget.
                                </p>
                            </li>
                        </ul>
                        {/* <!-- <button className="btn large order-btn wow zoomIn">"Hey Meta" "Record a Video"</button> --> */}
                        <button className="btn large order-btn wow zoomIn">"Hey Meta, Record a Video"</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default SpecialLunchOffer